// DressFit prices are in euro cents wherever it ships; separator and symbol placement follow the locale.
export const formatPriceCents = (cents: number, localeCode: string): string =>
  new Intl.NumberFormat(localeCode, { style: 'currency', currency: 'EUR' }).format(cents / 100);
